import React from 'react';
import { Descriptions } from 'antd';
import { Customer } from '../../../../../core-module/services/logistics/types';

interface Props {
  readonly customer: Customer;
}

const ProfileComponent: React.FC<Props> = ({ customer }) => {
  return (
    <>
      <Descriptions bordered column={1}>
        <Descriptions.Item label='Voornaam'>
          <span>{customer.first_name}</span>
        </Descriptions.Item>
        <Descriptions.Item label='Achternaam'>
          <span>
            {customer.prefix ? `${customer.prefix} ` : ''}
            {customer.last_name}
          </span>
        </Descriptions.Item>
        <Descriptions.Item label='Klantnummer'>
          <span>{customer.customer_id}</span>
        </Descriptions.Item>
        <Descriptions.Item label='Telefoonnummer'>
          <span>
            {customer.phone && customer.phone_2 && customer.phone !== customer.phone_2
              ? `${customer.phone} | ${customer.phone_2}`
              : customer.phone || customer.phone_2}
          </span>
        </Descriptions.Item>
        <Descriptions.Item label='Vaste route opmerking'>
          <span>{customer.routelijst_opmerking}</span>
        </Descriptions.Item>
        <Descriptions.Item label='Af te geven maaltijdoverzichten'>
          <span>{customer.papieren_week_menu}</span>
        </Descriptions.Item>
        <Descriptions.Item label='Standaard portie'>
          <span>{customer.default_portie ?? '-'}</span>
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

export { ProfileComponent };
